import React from "react";
import PivotTable from "./PivotTable";
import "./DatasetBuilder.scss";
import { VETSTAT_UI } from "../../strings";

const DatasetBuilder = () => {
  return (
    <div className="datasetBuilderScreen">
      <PivotTable 
        title={VETSTAT_UI.datasetBuilder.table41Title}
        description={VETSTAT_UI.datasetBuilder.table41Description}
        rowFields={["newdyreart_uk", "newaldersgruppe_uk"]}
        colField="new_uk_ema"
        rowLabel={VETSTAT_UI.datasetBuilder.table41RowLabel}
        colLabel={VETSTAT_UI.datasetBuilder.table41ColLabel}
      />
      
      <div style={{ height: '2rem' }}></div>

      <PivotTable 
        title={VETSTAT_UI.datasetBuilder.annualTrendTitle}
        description={VETSTAT_UI.datasetBuilder.annualTrendDescription}
        rowFields={["newdyreart_uk", "newaldersgruppe_uk", "aar"]}
        rowLabel={VETSTAT_UI.datasetBuilder.annualTrendRowLabel}
        colLabel={VETSTAT_UI.datasetBuilder.annualTrendColLabel}
        showSpeciesFilter={false}
        showTotalColumn={true}
        hideSubtotalValues={true}
        precision={2}
      />
    </div>
  );
};

export default DatasetBuilder;
